import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function DuplicateIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="14"
        height="16"
        viewBox="0 0 14 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3 0H13C13.6 0 14 0.4 14 1V13H12V2H3V0Z" />
        <path d="M1 4H9C9.6 4 10 4.4 10 5V15C10 15.6 9.6 16 9 16H1C0.4 16 0 15.6 0 15V5C0 4.4 0.4 4 1 4Z" />
      </svg>
    </Icon>
  );
}
